import BooleanIndicatorIcon from './BooleanIndicatorIcon';

interface EmployeeAdjustedIndicatorProps {
  isEmployeeAdjusted: boolean;
}

const EmployeeAdjustedIndicator = ({ isEmployeeAdjusted }: EmployeeAdjustedIndicatorProps): JSX.Element => (
  <BooleanIndicatorIcon value={isEmployeeAdjusted} warning />
);

export default EmployeeAdjustedIndicator;
